import { SocialPlatform, type AppConfig } from "@iyk/vf-app-config"
import { Duration } from "effect"

export const appConfig: AppConfig<"cmat"> = {
  appId: "cmat",
  cookiePrefix: "cm_v2",
  lang: "EN",
  artist: {
    name: "CMAT"
  },
  meta: {
    description: "CMAT"
  },
  emailSender: {
    name: "CMAT",
    email: "cmat@iyk.app"
  },
  s3: {
    get assets() {
      const baseUrl = "https://assets.iyk.app"
      return {
        baseUrl,
        vfUrl: `${baseUrl}/vf`,
        appUrl: `${baseUrl}/${appConfig.appId}`
      }
    },
    get files() {
      return {
        exclusives: "cmat-exclusives",
        fanClips: "cmat-fan-clips",
        merchSkus: "cmat-merch-skus",
        playlistCoverImages: "cmat-playlist-cover-images",
        showImages: "cmat-shows",
        showCheckInRequestImages: "cmat-show-check-in-requests"
      }
    },
    get music() {
      return {
        trackAudios: "cmat-playlist-tracks",
        playlistDownloadFiles: "cmat-playlist-download-files"
      }
    }
  },
  merch: {
    initialOwnerId: "f4513e00-bb5f-4623-ac4b-9c5e06c45bf5",
    initialOwnerAddress: "0xc4002adAa1B14E74DF40c5135Fdce0ABC721E4Ca"
  },
  tasks: {
    exclusiveLinkDelay: Duration.hours(1)
  },
  checkIn: {
    hidePrompt: true
  },
  shopUrl: "https://cmat.terrible.group",
  socialLinks: [
    {
      platform: SocialPlatform.Instagram,
      label: "Instagram",
      href: "https://www.instagram.com/cmatbaby"
    },
    {
      platform: SocialPlatform.TikTok,
      label: "TikTok",
      href: "https://www.tiktok.com/@cmatbaby"
    },
    {
      platform: SocialPlatform.Youtube,
      label: "YouTube",
      href: "https://www.youtube.com/@cmatbaby"
    },
    {
      platform: SocialPlatform.Spotify,
      label: "Spotify",
      href: "https://open.spotify.com/playlist/5Ru6BBf3GLMNBO8hNN85sB?si=8fffed260e364366"
    },
    {
      platform: SocialPlatform.AppleMusic,
      label: "Apple Music",
      href: "https://music.apple.com/gb/artist/cmat/1506697965"
    },
    {
      platform: SocialPlatform.Twitter,
      label: "X",
      href: "https://twitter.com/cmatbaby"
    }
  ],
  joinProof: null,
  get assets() {
    return {
      images: {
        avatar: `${appConfig.s3.assets.appUrl}/avatar.webp`,
        og: `${appConfig.s3.assets.appUrl}/og_image.png`,
        logo: {
          url: `${appConfig.s3.assets.appUrl}/app_logo.png`,
          width: 86
        },
        email: {
          logo: {
            url: `${appConfig.s3.assets.appUrl}/app_logo_dark.png`,
            width: 86
          }
        },
        background: `${appConfig.s3.assets.appUrl}/profile_background.webp`,
        howToTap: null,
        roulette: {
          images: Array.from({ length: 6 }, (_, i) => `${appConfig.s3.assets.appUrl}/roulette/${i + 1}.webp`)
        },
        enableLocation: {
          ios: {
            step1: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_ios_1.png`,
            step2: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_ios_2.png`
          },
          android: {
            step1: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_android.png`
          }
        }
      },
      videos: {
        marquee: null,
        howToTap: null
      },
      documents: {
        privacyPolicy: `${appConfig.s3.assets.baseUrl}/iyk-privacy-policy.pdf`,
        termsOfService: `${appConfig.s3.assets.baseUrl}/iyk-terms-of-service.pdf`,
        artistPrivacyPolicy: "https://tools.sonymusiccreative.com/privacy",
        artistTermsOfService: null,
        sweepstakeRules: null
      }
    }
  }
}
